<div class="remark-requested">
  <!-- Date time attribute is used within RecordingPlaybackTabService -->
  <ftr-date
    [date]="range.startTime"
    [format]="dateFormats.Time"
    [attr.data-datetime]="range.startTime"
    class="remark-requested__time"
  ></ftr-date>
  <div class="remark-requested__content">
    <span class="remark-requested__content-end-time">
      <span class="remark-requested__content-end-time-hyphen">-</span>
      <ftr-date [date]="range.endTime" [format]="dateFormats.Time"></ftr-date>
    </span>
    <div class="remark-requested__content-container">
      <span class="remark-requested__content-title">
        <ftr-loader
          [isLoading]="true"
          [iconOnly]="true"
          [inline]="true"
          class="remark-requested__content-loader"
        ></ftr-loader>
        Generating text
      </span>
    </div>
  </div>
</div>
